import { GridColDef } from '@mui/x-data-grid';

const DAY_MS = 24 * 60 * 60 * 1000;

// Calendar days, not 24h periods, so the count always agrees with the date shown beside it.
const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

// e.g. "Sep 22, 2026 (14 days)". Days only: the product team acts on how many days customers
// have waited, so hours and minutes would add noise. A same-day subscription reads "Today".
const formatWaitingSince = (value: string | null) => {
  if (!value) return '—';
  const since = new Date(value);
  const days = Math.round((startOfDay(new Date()) - startOfDay(since)) / DAY_MS);
  const elapsed = days < 1 ? 'Today' : days === 1 ? '1 day' : `${days} days`;
  const date = since.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return `${date} (${elapsed})`;
};

export const getProductStockSubscriptionsColumns = (): GridColDef[] => [
  {
    field: 'sku',
    headerName: 'SKU',
    flex: 0.8,
  },
  {
    field: 'product_name',
    headerName: 'Product Name',
    flex: 2,
  },
  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
    valueFormatter: (value: string | null) => value ?? '—',
  },
  {
    field: 'subscriber_count',
    headerName: 'Subscribers',
    flex: 0.7,
  },
  {
    field: 'waiting_since',
    headerName: 'Waiting Since',
    flex: 1.2,
    valueFormatter: formatWaitingSince,
  },
];
